import AuthSocials from './auth_soc_container';

export default AuthSocials;